// SEO Configuration for all pages
const siteConfig = {
  siteName: "Make Loan Eazy",
  siteUrl: "https://makeloaneazy.com",
  defaultImage: `${typeof window !== 'undefined' ? window.location.origin : 'https://makeloaneazy.com'}/mle-og.jpeg`,
  twitterHandle: "@makeloaneazy",
  description: "Compare loans, get personalized advice, and make confident financial decisions with Make Loan Eazy."
};

export const seoConfig = {
  "/": {
    title: "Make Loan Eazy - Compare Loans & Get Best Rates",
    description: "Compare loans, fixed deposits, and get the best financial rates in India. Make informed decisions with Make Loan Eazy's comprehensive loan comparison tools.",
    keywords: "loan comparison, best loan rates, fixed deposit, EMI Calculator, personal loan, home loan, India",
    image: siteConfig.defaultImage
  },
  "/news": {
    title: "Financial News & Updates - Make Loan Eazy",
    description: "Stay updated with the latest financial news, banking updates, and loan market trends in India.",
    keywords: "financial news, banking news, loan updates, India finance",
    image: siteConfig.defaultImage
  },
  "/calc": {
    title: "EMI Calculator - EMI, Loan & FD Calculator",
    description: "Calculate EMI, loan repayments, and fixed deposit returns with our comprehensive EMI Calculator tools.",
    keywords: "EMI calculator, loan calculator, FD calculator, EMI Calculator, India",
    image: siteConfig.defaultImage
  },
  "/about": {
    title: "About Us - Make Loan Eazy | Your Trusted Loan Partner",
    description: "Learn about Make Loan Eazy's mission to simplify loan comparison and help Indians make better financial decisions.",
    keywords: "about make loan eazy, loan comparison platform, financial services India",
    image: siteConfig.defaultImage
  },
  "/fixed-deposit": {
    title: "Fixed Deposit Plans - Compare Best FD Rates in India",
    description: "Compare fixed deposit plans from top banks. Earn up to 9.5% p.a. with secure, RBI-insured bank FDs.",
    keywords: "fixed deposit, FD rates, best FD plans, bank FD India, high return FD",
    image: siteConfig.defaultImage
  },
  "/contact": {
    title: "Contact Us - Make Loan Eazy Support",
    description: "Get in touch with Make Loan Eazy for loan queries, support, or partnership opportunities.",
    keywords: "contact, support, customer service, make loan eazy",
    image: siteConfig.defaultImage
  },
  "/blog": {
    title: "Blog - Financial Tips, Loan Guides & Money Management",
    description: "Read expert articles on loans, financial planning, money management, and investment tips for Indians.",
    keywords: "financial blog, loan tips, money management, investment guide India",
    image: siteConfig.defaultImage
  },
  "/settings": {
    title: "Settings - Make Loan Eazy",
    description: "Manage your preferences and account settings on Make Loan Eazy.",
    keywords: "settings, account, preferences",
    image: siteConfig.defaultImage
  },
  "/terms": {
    title: "Terms & Conditions - Make Loan Eazy",
    description: "Read our terms and conditions for using Make Loan Eazy services.",
    keywords: "terms and conditions, user agreement, legal",
    image: siteConfig.defaultImage
  },
  "/privacy": {
    title: "Privacy Policy - Make Loan Eazy",
    description: "Learn how Make Loan Eazy protects your data and respects your privacy.",
    keywords: "privacy policy, data protection, security",
    image: siteConfig.defaultImage
  },
  "/admin": {
    title: "Admin Panel - Make Loan Eazy",
    description: "Administrative dashboard for Make Loan Eazy.",
    keywords: "admin, dashboard, management",
    image: siteConfig.defaultImage
  }
};

// Function to get SEO data for a specific route
export const getSeoData = (path) => {
  return seoConfig[path] || seoConfig["/"];
};

// Function to generate dynamic blog SEO
export const getBlogSeoData = (blog) => {
  if (!blog) return getSeoData("/blog");
  
  return {
    title: `${blog.title} - Make Loan Eazy Blog`,
    description: blog.meta_description || blog.excerpt || `Read about ${blog.title} on Make Loan Eazy blog.`,
    keywords: blog.tags?.join(", ") || "financial blog, loan tips",
    image: blog.featured_image || siteConfig.defaultImage,
    author: blog.author || "Make Loan Eazy Team",
    publishedDate: blog.created_at || blog.published_date,
    modifiedDate: blog.updated_at,
    category: blog.category_name || "Financial Tips"
  };
};

export default siteConfig;
